var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selection
    ? _c(
        "div",
        {
          staticClass: "selection-wapper",
          class: [
            "selection-data",
            _vm.priceChange,
            {
              "longprice-selection":
                _vm.formatedSelectionPrice &&
                _vm.formatedSelectionPrice.length > _vm.selectionLength
            },
            { "estmated-price": _vm.estimatedOrCurrentPrice === "estimated" },
            { "current-price": _vm.estimatedOrCurrentPrice === "current" }
          ],
          attrs: {
            idfoselection:
              (_vm.selection &&
                _vm.selection.idfoselection &&
                _vm.selection.idfoselection.toString()) ||
              "null"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "value",
              class: {
                "show-one-in-one-line": _vm.showOneInOneLine,
                suspended:
                  !_vm.istradable ||
                  _vm.selection.idfobolifestate === "NR" ||
                  _vm.selectionHasSuspensionPerBusinessChannel
              }
            },
            [
              _c("div", { staticClass: "sh" }, [
                _vm.istradable &&
                _vm.selection.idfobolifestate !== "NR" &&
                !_vm.selectionHasSuspensionPerBusinessChannel &&
                _vm.estimatedOrCurrentPrice === "current"
                  ? _c(
                      "div",
                      {
                        staticClass: "selectionprice",
                        class: {
                          noprice: !_vm.formatedSelectionPrice,
                          longprice:
                            _vm.formatedSelectionPrice &&
                            _vm.formatedSelectionPrice.length >
                              _vm.selectionLength,
                          varylongprice:
                            _vm.formatedSelectionPrice &&
                            _vm.formatedSelectionPrice.length >
                              _vm.secondselectionLength
                        }
                      },
                      [_vm._v(_vm._s(_vm.formatedSelectionPrice || "--"))]
                    )
                  : _vm.istradable &&
                    _vm.selection.idfobolifestate !== "NR" &&
                    !_vm.selectionHasSuspensionPerBusinessChannel &&
                    _vm.estimatedOrCurrentPrice === "estimated"
                  ? _c(
                      "div",
                      {
                        staticClass: "selectionprice",
                        class: {
                          noprice: !_vm.formatedSelectionEstimatedPrice,
                          longprice:
                            _vm.formatedSelectionEstimatedPrice &&
                            _vm.formatedSelectionEstimatedPrice.length >
                              _vm.selectionLength,
                          varylongprice:
                            _vm.formatedSelectionEstimatedPrice &&
                            _vm.formatedSelectionEstimatedPrice.length >
                              _vm.secondselectionLength
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.formatedSelectionEstimatedPrice || "--")
                        )
                      ]
                    )
                  : _c(
                      "div",
                      { staticClass: "selectionprice suspended" },
                      [_c("icon", { attrs: { name: "icon-lock" } })],
                      1
                    )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.isDebug
            ? _c("div", { staticStyle: { "font-size": "10px" } }, [
                _vm._v(
                  "\n    had " +
                    _vm._s(_vm.selection.hadvalue || "--") +
                    "\n    io " +
                    _vm._s(_vm.selection.internalorder || "--")
                ),
                _c("br"),
                _vm._v(
                  "\n    ch " +
                    _vm._s(_vm.selection.currenthandicap || "--") +
                    "\n    p " +
                    _vm._s(
                      (_vm.selection.price && _vm.selection.price.toFixed(2)) ||
                        "--"
                    ) +
                    "\n  "
                )
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5af616af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5af616af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/oddsBoost/oddsBoostSelection.vue
// module id = null
// module chunks = 